// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home {
  width: 100%;
  padding: 16px 12px 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* supplementary entry: deliberately low-emphasis, set apart from the two primary actions */
}
.home-welcome {
  text-align: center;
}
.home-welcome h1 {
  color: var(--eta-color-theme);
  font-size: 34px;
  font-weight: 700;
  margin: 0 0 8px;
}
.home-welcome p {
  color: #333;
  font-size: 18px;
  margin: 0;
}
.home-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 14px;
}
.home-btn {
  height: auto;
  min-height: 86px;
  border: none;
  border-radius: 14px;
  color: #fff !important;
  font-size: 20px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
  padding: 0 22px;
}
.home-btn svg {
  font-size: 22px;
}
.home-btn:hover {
  opacity: 0.92;
}
.home-btn-from {
  flex: 1 1 45%;
  background: var(--eta-color-theme) !important;
}
.home-btn-to {
  flex: 1 1 45%;
  background: #f5a623 !important;
}
.home-secondary {
  margin-top: -8px;
  padding-top: 16px;
  border-top: 1px solid var(--eta-border-color);
}
.home-shuttle-link {
  /* negative margin keeps the label flush with the primary buttons above,
           while the hover highlight still gets breathing room around the text */
  width: calc(100% + 20px);
  margin: 0 -10px;
  height: auto;
  min-height: 44px;
  padding: 8px 10px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #666 !important;
  font-size: 15px;
  font-weight: 600;
}
.home-shuttle-link span {
  flex: 1;
  text-align: left;
}
.home-shuttle-link-icon {
  flex-shrink: 0;
  font-size: 15px;
  color: var(--eta-color-theme);
  opacity: 0.55;
}
.home-shuttle-link-chevron {
  flex-shrink: 0;
  font-size: 12px;
  color: #bbb;
}
.home-shuttle-link:hover {
  color: var(--eta-color-theme) !important;
}
.home-shuttle-link:hover .home-shuttle-link-icon {
  opacity: 0.85;
}
/*# sourceMappingURL=HomePage.css.map */`, "",{"version":3,"sources":["webpack://./HomePage.less","webpack://./src/containers/HomePage/HomePage.less"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;ECCF,2FAA2F;AAC7F;ADAI;EACI,kBAAA;ACER;ADHI;EAIQ,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;ACEZ;ADTI;EAWQ,WAAA;EACA,eAAA;EACA,SAAA;ACCZ;ADGI;EACI,aAAA;EACA,eAAA;EACA,SAAA;ACDR;ADII;EACI,YAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,SAAA;EACA,eAAA;ACFR;ADVI;EAeQ,eAAA;ACFZ;ADKQ;EACI,aAAA;ACHZ;ADOI;EACI,aAAA;EACA,6CAAA;ACLR;ADQI;EACI,aAAA;EACA,8BAAA;ACNR;ADUI;EACI,gBAAA;EACA,iBAAA;EACA,6CAAA;ACRR;ADWI;ECTF;gFAC8E;EDWxE,wBAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;ACTR;ADLI;EAiBQ,OAAA;EACA,gBAAA;ACTZ;ADYQ;EACI,cAAA;EACA,eAAA;EACA,6BAAA;EACA,aAAA;ACVZ;ADaQ;EACI,cAAA;EACA,eAAA;EACA,WAAA;ACXZ;ADcQ;EACI,wCAAA;ACZZ;ADWQ;EAIQ,aAAA;ACZhB;AACA,uCAAuC","sourcesContent":[".home {\n    width: 100%;\n    padding: 16px 12px 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    &-welcome {\n        text-align: center;\n\n        h1 {\n            color: var(--eta-color-theme);\n            font-size: 34px;\n            font-weight: 700;\n            margin: 0 0 8px;\n        }\n\n        p {\n            color: #333;\n            font-size: 18px;\n            margin: 0;\n        }\n    }\n\n    &-actions {\n        display: flex;\n        flex-wrap: wrap;\n        gap: 14px;\n    }\n\n    &-btn {\n        height: auto;\n        min-height: 86px;\n        border: none;\n        border-radius: 14px;\n        color: #fff !important;\n        font-size: 20px;\n        font-weight: 600;\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        gap: 12px;\n        padding: 0 22px;\n\n        svg {\n            font-size: 22px;\n        }\n\n        &:hover {\n            opacity: 0.92;\n        }\n    }\n\n    &-btn-from {\n        flex: 1 1 45%;\n        background: var(--eta-color-theme) !important;\n    }\n\n    &-btn-to {\n        flex: 1 1 45%;\n        background: #f5a623 !important;\n    }\n\n    /* supplementary entry: deliberately low-emphasis, set apart from the two primary actions */\n    &-secondary {\n        margin-top: -8px;\n        padding-top: 16px;\n        border-top: 1px solid var(--eta-border-color);\n    }\n\n    &-shuttle-link {\n        /* negative margin keeps the label flush with the primary buttons above,\n           while the hover highlight still gets breathing room around the text */\n        width: calc(100% + 20px);\n        margin: 0 -10px;\n        height: auto;\n        min-height: 44px;\n        padding: 8px 10px;\n        border-radius: 10px;\n        display: flex;\n        align-items: center;\n        gap: 10px;\n        color: #666 !important;\n        font-size: 15px;\n        font-weight: 600;\n\n        span {\n            flex: 1;\n            text-align: left;\n        }\n\n        &-icon {\n            flex-shrink: 0;\n            font-size: 15px;\n            color: var(--eta-color-theme);\n            opacity: 0.55;\n        }\n\n        &-chevron {\n            flex-shrink: 0;\n            font-size: 12px;\n            color: #bbb;\n        }\n\n        &:hover {\n            color: var(--eta-color-theme) !important;\n\n            .home-shuttle-link-icon {\n                opacity: 0.85;\n            }\n        }\n    }\n}\n",".home {\n  width: 100%;\n  padding: 16px 12px 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  /* supplementary entry: deliberately low-emphasis, set apart from the two primary actions */\n}\n.home-welcome {\n  text-align: center;\n}\n.home-welcome h1 {\n  color: var(--eta-color-theme);\n  font-size: 34px;\n  font-weight: 700;\n  margin: 0 0 8px;\n}\n.home-welcome p {\n  color: #333;\n  font-size: 18px;\n  margin: 0;\n}\n.home-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 14px;\n}\n.home-btn {\n  height: auto;\n  min-height: 86px;\n  border: none;\n  border-radius: 14px;\n  color: #fff !important;\n  font-size: 20px;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 12px;\n  padding: 0 22px;\n}\n.home-btn svg {\n  font-size: 22px;\n}\n.home-btn:hover {\n  opacity: 0.92;\n}\n.home-btn-from {\n  flex: 1 1 45%;\n  background: var(--eta-color-theme) !important;\n}\n.home-btn-to {\n  flex: 1 1 45%;\n  background: #f5a623 !important;\n}\n.home-secondary {\n  margin-top: -8px;\n  padding-top: 16px;\n  border-top: 1px solid var(--eta-border-color);\n}\n.home-shuttle-link {\n  /* negative margin keeps the label flush with the primary buttons above,\n           while the hover highlight still gets breathing room around the text */\n  width: calc(100% + 20px);\n  margin: 0 -10px;\n  height: auto;\n  min-height: 44px;\n  padding: 8px 10px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  color: #666 !important;\n  font-size: 15px;\n  font-weight: 600;\n}\n.home-shuttle-link span {\n  flex: 1;\n  text-align: left;\n}\n.home-shuttle-link-icon {\n  flex-shrink: 0;\n  font-size: 15px;\n  color: var(--eta-color-theme);\n  opacity: 0.55;\n}\n.home-shuttle-link-chevron {\n  flex-shrink: 0;\n  font-size: 12px;\n  color: #bbb;\n}\n.home-shuttle-link:hover {\n  color: var(--eta-color-theme) !important;\n}\n.home-shuttle-link:hover .home-shuttle-link-icon {\n  opacity: 0.85;\n}\n/*# sourceMappingURL=HomePage.css.map */"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
